<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-row justify-center items-center">

            <div class="vx-col p-20">
                <div class="mb-5 text-left">
                    <img src="@/assets/images/logo/logo-w.svg" alt="CFC Solutions"
                         class="fill-current stroke-current text-white inline-block">
                </div>
                <h1 class="d-theme-text-inverse text-2xl md:text-4xl mb-5">Outil de gestion &amp; <br>suivi de
                    facturation</h1>
                <h4 class="d-theme-text-inverse text-opacity-75 font-normal">Le plus court chemin <br>de la facture au
                    règlement</h4>
            </div>

            <div class="vx-col">
                <vx-card>
                    <div slot="no-body" class="full-page-bg-white rounded-lg d-theme-dark-bg">
                        <div class="p-10 login-tabs-container">

                            <div class="vx-card__title mb-4">
                                <h4 class="mb-4">Vérification du compte</h4>
                                <p>
                                    C'est votre première connexion depuis la dernière mise à jour de l'application.
                                </p>
                                <p>
                                    Veuillez mettre à jour vos informations de connexion.
                                </p>
                            </div>

                            <div>
                                <form action="#" @submit.prevent=""
                                      @keydown.enter="validadeFields ? updateUserInfos(): false">
                                    <vs-input
                                        v-validate="'required|email'"
                                        data-vv-validate-on="change|input|keyup"
                                        name="email"
                                        icon-no-border
                                        icon="icon icon-mail"
                                        icon-pack="feather"
                                        placeholder="votre email"
                                        v-model="email"
                                        class="w-full mt-8"/>
                                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                    <vs-input
                                        v-validate="{required : true,regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/}"
                                        data-vv-validate-on="change|input|keyup"
                                        name="password"
                                        type="password"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        placeholder="votre nouveau mot de passe"
                                        v-model="password"
                                        ref="password"
                                        class="w-full mt-8"/>

                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                        v-validate="{required : true,confirmed: 'password'}"
                                        data-vv-validate-on="change|input|keyup"
                                        name="password_confirmation"
                                        type="password"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        placeholder="confirmer votre nouveau mot de passe"
                                        v-model="password_confirmation"
                                        class="w-full mt-8"/>


                                    <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <vs-button type="border" @click="doLogout">
                                            Annuler
                                        </vs-button>
                                        <vs-button :disabled="!validadeFields" @click="updateUserInfos" class="float-right">
                                            Envoyer
                                        </vs-button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
// For custom error message
import {Validator} from 'vee-validate'

const dict = {
    custom: {
        email: {
            required: 'Merci de saisir un email',
            email: 'Le format d’email n’est pas valide'
        },
        password: {
            required: 'Merci de saisir un mot de passe',
            regex: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial'
        },
        password_confirmation: {
            required: 'Merci de confirmer votre mot de passe',
            confirmed: 'Les mots de passe ne correspondent pas'
        }
    }
}

// register custom messages
Validator.localize('fr', dict)

export default {
    data() {
        return {
            email: '',
            password: '',
            password_confirmation: '',
        }
    },
    computed: {
        ...mapGetters('user', ['activeUser']),
        validateForm() {
            return this.email && this.password && this.password_confirmation;
        },
        validadeFields() {
            return this.email && this.password && this.password_confirmation;
        }
    },
    mounted() {
        this.email = this.activeUser.email;
    },
    methods: {
        ...mapActions('user', ['changeUserCredentials','logout','login']),
        doLogout() {
            this.$acl.change('subscriber');
            this.logout();
        },
        updateUserInfos() {

            if (!this.validateForm) return

            this.$vs.loading()
            this.error = false

            this.changeUserCredentials({
                id: this.activeUser.id,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
            }).then(() => {
                this.$vs.loading.close()
                this.login({
                    email: this.email,
                    password: this.password,
                }).then(() => {
                    if ((JSON.parse(this.activeUser.roles).includes('ROLE_ADMIN') || JSON.parse(this.activeUser.roles).includes('ROLE_ECHEANCEUR') || JSON.parse(this.activeUser.roles).includes('ROLE_MANAGER'))) {
                        this.$acl.change('admin')
                    } else if (JSON.parse(this.activeUser.roles).includes('ROLE_USER')) {
                        this.$acl.change('subscriber')
                    }
                    this.$router.push({path: '/'})
                });
            }).catch(() => {
                this.$vs.loading.close()
                this.error = true
            })
        }
    }
}
</script>

<style lang="scss">
.login-tabs-container{
    max-width: 623px;
}
</style>
